import { NOTE_LEVEL_LABELS, noteLevelDescription } from '@/lib/note-format';
import {
  NOTE_VISIBILITIES,
  type NoteVisibility,
  type UserRole,
  canUseNoteVisibility,
} from '@mss_creator/shared';
import { Select } from '@pms-digital/design-system';

export interface NoteLevelPickerProps {
  value: NoteVisibility;
  onChange: (visibility: NoteVisibility) => void;
  /** The role in force: a client role is not offered « Équipe PMS ». */
  role: UserRole;
  /** Named in the description of the Client level. */
  companyName: string;
}

function isNoteVisibility(value: string): value is NoteVisibility {
  return (NOTE_VISIBILITIES as readonly string[]).includes(value);
}

/**
 * The level of a note, picked in the `Select` of the design system among the
 * levels the role may write; who will read the current level is said under it
 * (planche 11).
 */
export function NoteLevelPicker({ value, onChange, role, companyName }: NoteLevelPickerProps) {
  return (
    <Select
      label={<span className="sr-only">Niveau de la note</span>}
      help={noteLevelDescription(value, companyName)}
      value={value}
      onValueChange={(next) => {
        if (isNoteVisibility(next)) onChange(next);
      }}
      options={NOTE_VISIBILITIES.filter((level) => canUseNoteVisibility(role, level)).map(
        (level) => ({ value: level, label: NOTE_LEVEL_LABELS[level] }),
      )}
    />
  );
}
